const addThumbBtnsClickHandlers = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb
    .slideNodes()
    .map((slide) => slide.querySelector("button") || slide);

  const scrollToIndex = slidesThumbs.map(
    (_, index) => () => emblaApiMain.scrollTo(index)
  );

  slidesThumbs.forEach((slideNode, index) => {
    slideNode.addEventListener("click", scrollToIndex[index], false);
  });

  return () => {
    slidesThumbs.forEach((slideNode, index) => {
      slideNode.removeEventListener("click", scrollToIndex[index], false);
    });
  };
};

const addToggleThumbBtnsActive = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();

  const toggleThumbBtnsState = () => {
    emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
    const previous = emblaApiMain.previousScrollSnap();
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs.forEach((thumb, index) => {
      if (index === selected) {
        thumb.classList.add("embla-thumbs__slide--selected");
      } else {
        thumb.classList.remove("embla-thumbs__slide--selected");
      }
    });
  };

  emblaApiMain.on("select", toggleThumbBtnsState);

  toggleThumbBtnsState();

  return () => {
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[selected].classList.remove("embla-thumbs__slide--selected");
    emblaApiMain.off("select", toggleThumbBtnsState);
  };
};

window.addDynamicSlides = function (
  slidesSrcArray,
  productId = null
) {
  const sliderElement = document.querySelector('product-media-slider');
  if (!sliderElement || !Array.isArray(slidesSrcArray)) return;

  const mainTrack = sliderElement.querySelector(".embla__container");
  const thumbsTrack = sliderElement.querySelector(".embla-thumbs__container");

  if (!mainTrack || !thumbsTrack) return;

  const currentSlideCount = mainTrack.children.length;  
  const ratio = ((1539 / 1946) * 100).toFixed(10); // 79.0917133589%
  const MAX_SLIDES = 6;

  Array.from(mainTrack.children)
    .filter(li => li.dataset.mediaId && li.dataset.mediaId.startsWith('dynamic-'))
    .forEach(el => el.remove());

  Array.from(thumbsTrack.children)
    .filter(li => li.dataset.mediaId && li.dataset.mediaId.startsWith('dynamic-'))
    .forEach(el => el.remove());

  const mainSlidesHTML = slidesSrcArray
  .map((src, index) => {
    const globalIndex = currentSlideCount + index;
    const mediaId = `dynamic-${index}`;

    return `
      <li class="opacity-100 animate-fade-in embla__slide product-media-slider__slide w-full shrink-0 sm:w-full sm:h-full" data-media-type="image" data-media-id=${mediaId}>
        <div class="relative" style="padding-bottom:${ratio}%">
          <img 
            src="${src}" 
            width="1946" 
            height="1539" 
            loading="${index === 0 ? "eager" : "lazy"}" 
            sizes="(max-width:639px)100vw,(max-width:767px)calc(50vw-2.25rem)" 
            alt="Preview of the personalized book" 
            class="absolute inset-0 object-cover w-full h-full product-media-slider__media-item"
            data-index="${globalIndex + 1}" 
            style="object-position: left;"
            ${index === 0 ? `data-preload="true"` : ""}
          >
          <button 
            class="absolute inset-0 w-full h-full product-modal-opener cursor-zoom-in -outline-offset-2 focus-visible:outline focus-visible:outline-2" 
            type="button" 
            aria-haspopup="dialog"
            data-media-id=${mediaId}
          >
            <span class="sr-only">Open media in modal</span>
          </button>
        </div>
      </li>
    `.trim();
  })
  .join("");

  const thumbsSlidesHTML = slidesSrcArray
  .map((src, index) => {
    const globalIndex = currentSlideCount + index;
    const mediaId = `dynamic-${index}`;
    const prodIdAttr = productId ? `data-product-id="${productId}"` : "";

    return `
      <li data-media-id="${mediaId}" ${prodIdAttr} class="embla-thumbs__slide" style="--pb-ratio:${ratio}%">
        <button type="button" data-media-id="${mediaId}" aria-label="Go to item ${
              globalIndex + 1
            }">
          <img 
            src="${src}" 
            alt="Preview of the personalized book" 
            width="208" 
            height="156" 
            loading="lazy" 
            class="product-media-slider__media-thumb"
          >
        </button>
      </li>
    `.trim();
  })
  .join("");

  mainTrack.insertAdjacentHTML("afterbegin", mainSlidesHTML);
  thumbsTrack.insertAdjacentHTML("afterbegin", thumbsSlidesHTML);

  const existingSlides = Array.from(mainTrack.querySelectorAll(".product-media-slider__slide"));
  const existingThumbs = Array.from(thumbsTrack.querySelectorAll(".embla-thumbs__slide"));
  const totalSlides = existingSlides.length + slidesSrcArray.length;
  const toHideCount = totalSlides > MAX_SLIDES ? totalSlides - MAX_SLIDES : 0;

  for (let i = totalSlides - toHideCount; i < totalSlides; i++) {
    if (existingSlides[i]) existingSlides[i].classList.add("hidden");
    if (existingThumbs[i]) existingThumbs[i].classList.add("hidden");
  }

  const mediaSliderComponent =
    sliderElement instanceof ProductMediaSlider
      ? sliderElement
      : sliderElement.closest("product-media-slider");

  if (
    mediaSliderComponent &&
    typeof mediaSliderComponent.reInit === "function"
  ) {
    mediaSliderComponent.reInit();
  }
};

class ProductMediaSlider extends HTMLElement {
  constructor() {
    super();

    const OPTIONS_THUMBS = {
      containScroll: 'keepSnaps',
      dragFree: true
    };

    this.desktopQuery = window.matchMedia("(min-width: 640px)");

    this.viewport = this.querySelector(".embla__viewport");
    this.thumbnailsViewport = this.querySelector(".embla-thumbs__viewport");
    this.slider = EmblaCarousel(
      this.viewport,
      {
        loop: true,
        align: "start",
        breakpoints: {
          "(min-width:640px)": {
            inViewThreshold: 1,
            active: false,
          },
        },
      },
      [EmblaCarouselClassNames()]
    );

    this.thumbnailsSlider = EmblaCarousel(
      this.thumbnailsViewport,
      OPTIONS_THUMBS
    );

    this.setupThumbnails = this.setupThumbnails.bind(this);

    this.variantMediaContainer = this.querySelector(".js-variant-media");

    this.prevButton = this.querySelector(".embla__prev-button");
    this.nextButton = this.querySelector(".embla__next-button");

    this.handleSelect = this.handleSelect.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.slider
      .on("init", this.handleSelect)
      .on("select", this.handleSelect)
      .on("reInit", () => {
        this.handleSelect();
        this.thumbnailsSlider.reInit();
      });

    this.thumbnailsSlider
      .on("init", this.setupThumbnails)
      .on("reInit", this.setupThumbnails);

    this.slider.on("destroy", () => {
      this.removeThumbBtnsClickHandlers();
      this.removeToggleThumbBtnsActive();
    });
  }

  setupThumbnails() {
    if (this.removeThumbBtnsClickHandlers) {
      this.removeThumbBtnsClickHandlers();
    }
    if (this.removeToggleThumbBtnsActive) {
      this.removeToggleThumbBtnsActive();
    }
    this.removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
      this.slider,
      this.thumbnailsSlider
    );
    this.removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
      this.slider,
      this.thumbnailsSlider
    );
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    if (this.slider) {
      this.slider.destroy();
      this.slider = null;
    }
    if (this.thumbnailsSlider) {
      this.thumbnailsSlider.destroy();
      this.thumbnailsSlider = null;
    }
    this.removeEventListener("click", this.handleClick);
  }

  handleClick(event) {
    const modalOpener = event.target.closest(".product-modal-opener");
    if (modalOpener) {
      const productModal = document.getElementById(this.dataset.modalId);
      productModal.show(modalOpener.dataset.mediaId);
    }
  }

  reInit(index) {
    this.slider.reInit();
    if (typeof index === "number") {
      requestAnimationFrame(() => {
        this.slider.scrollTo(index);
      });
    }
  }

  scrollToMedia(mediaId) {
    this.slider.slideNodes().find((slide, index) => {
      if (slide.dataset.mediaId === mediaId) {
        this.slider.scrollTo(index);
        return true;
      }
    });
  }

  handleSelect() {
    const slidesInView = this.slider.slidesInView(true);
    const onDesktop = this.desktopQuery.matches;
    this.slider.slideNodes().forEach((slide, i) => {
      const inView = slidesInView.includes(i);
      const video = slide.querySelector("slider-video");
      const button = slide.querySelector("button");
      if (video) {
        if (inView) {
          video.play();
        } else {
          video.stop();
        }
      }
      if (onDesktop || inView) {
        if (button) {
          button.removeAttribute("tabindex");
        }
        slide.removeAttribute("aria-hidden");
      } else {
        if (button) {
          button.setAttribute("tabindex", "-1");
        }
        slide.setAttribute("aria-hidden", "true");
      }
    });
  }
}
customElements.define("product-media-slider", ProductMediaSlider);
